import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '@/redux/rootReducer'

export const selectAppReady = (state: RootState): boolean => state.app.ready
export const selectAppSettings = (state: RootState) => state.app.settings
export const selectBackgroundTasks = (state: RootState) => state.app.backgroundTasks

type AppReducerState = {
  backgroundTasks: Record<string, boolean>
  ready: boolean
  settings: {
    showFreshworkWidget: boolean
    autoSwitchOfflineMode: boolean
    showOfflineButton: boolean
    showPatientQueue: boolean
    preferWaitingRoom: boolean
  }
}

const initialState: AppReducerState = {
  backgroundTasks: {},
  ready: false,
  settings: {
    showFreshworkWidget: (localStorage.getItem('showFreshworkWidget') ?? 'true') === 'true',
    autoSwitchOfflineMode: (localStorage.getItem('autoSwitchOfflineMode') ?? 'false') === 'true',
    showOfflineButton: (localStorage.getItem('showOfflineButton') ?? 'false') === 'true',
    showPatientQueue: (localStorage.getItem('showPatientQueue') ?? 'false') === 'true',
    preferWaitingRoom: (localStorage.getItem('preferWaitingRoom') ?? 'false') === 'true',
  }
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppReady(state, action: PayloadAction<boolean>) {
      state.ready = action.payload
    },
    startBackgroundCheckDownloadSpeed(state) {
      state.backgroundTasks.checkDownloadSpeed = true
    },
    stopBackgroundCheckDownloadSpeed(state) {
      state.backgroundTasks.checkDownloadSpeed = false
    },
    startBackgroundCheckUploadSpeed(state) {
      state.backgroundTasks.checkUploadSpeed = true
    },
    stopBackgroundCheckUploadSpeed(state) {
      state.backgroundTasks.checkUploadSpeed = false
    },
    startBackgroundRequestRpiId(state, action: PayloadAction<string>) {
      state.backgroundTasks.requestRpiId = true
    },
    stopBackgroundRequestRpiId(state) {
      state.backgroundTasks.requestRpiId = false
    },
    setAppSettings(state, action: PayloadAction<Partial<AppReducerState['settings']>>) {
      state.settings = { ...state.settings, ...action.payload }
    }
  },
})

export const {
  setAppReady,
  startBackgroundCheckDownloadSpeed,
  stopBackgroundCheckDownloadSpeed,
  startBackgroundCheckUploadSpeed,
  stopBackgroundCheckUploadSpeed,
  startBackgroundRequestRpiId,
  stopBackgroundRequestRpiId,
  setAppSettings,
} = appSlice.actions

export default appSlice.reducer
